<template>
	<Tooltip :heading="translate('ui.exploration_speed')" customWidth="16rem">
		<template #element>
			<div
				class="exploration-box"
				v-if="showExplorationSpeed && !tutorialActive"
			>
				<span class="exploration-box__title">
					<span>{{ translate("ui.exploration") }}</span>
					<AppIconButton
						class="income-box__info"
						:type="IconTypes.INFO"
						:size="12"
						:iconSize="9"
					/>
				</span>
				<span class="exploration-box__value">
					{{ formatNumber(animatedValueRef) }}
					<AppMainIcon
						class="exploration-box__icon"
						:iconName="ResourceType.EXPLORATION_SPEED"
						:iconSize="16"
					/>
				</span>
			</div>
		</template>
		<template #tooltip>
			<span class="exploration-box__tooltip">
				{{ translate("ui.exploration_speed_description") }}
			</span>
		</template>
	</Tooltip>
</template>

<script lang="ts" setup>
import AppIconButton from "@/components/AppIconButton.vue";
import AppMainIcon from "@/components/AppMainIcon.vue";
import Tooltip from "@/components/Tooltip.vue";
import { NUMBER_ANIMATION_DURATION } from "@/config/constants";
import { ResourceType } from "@/game/entities/config/resources";
import useQuestStore from "@/store/useQuestStore";
import useResourcesStore from "@/store/useResourcesStore";
import useSettingsStore from "@/store/useSettingsStore";
import { IconTypes } from "@/types/ui";
import { formatNumber } from "@/utils/format";
import { translate } from "@/utils/translate";
import { storeToRefs } from "pinia";
import { shallowRef, watch } from "vue";

// @ts-expect-error - TS7016
import { linear, useTween } from "vue-femtotween";

const settingsStore = useSettingsStore();
const { showExplorationSpeed } = storeToRefs(settingsStore);

const resourcesStore = useResourcesStore();
const { explorationSpeed } = storeToRefs(resourcesStore);

const questStore = useQuestStore();
const { tutorialActive } = storeToRefs(questStore);

const valueRef = shallowRef<number>(explorationSpeed.value ?? 0);
const animatedValueRef = useTween(valueRef, {
	easing: linear,
	time: NUMBER_ANIMATION_DURATION,
	precision: 0,
});

watch(
	(): number => explorationSpeed.value,
	(): void => {
		animatedValueRef.stop();
		animatedValueRef.value = valueRef.value ?? 0;
		valueRef.value = explorationSpeed.value ?? 0;
	},
);
</script>

<style lang="scss" scoped>
.exploration-box {
	@include flex-col-center;
	position: relative;
	align-items: end;
	background: url($path-backgrounds + "exploration/exploration-bg.avif")
		center no-repeat;
	background-size: contain;
	padding: 0.625rem;
	width: 8.25rem;
	height: 3.125rem;

	&__title {
		@include flex-row-center;
		justify-content: flex-end;
		gap: 0.313rem;
		height: 1rem;
		color: #f2dcb5;
		font-weight: 500;
		font-size: 0.813rem;

		& > span {
			padding-bottom: 0.25rem;
		}
	}

	&__value {
		@include flex-row-center;
		gap: 0.375rem;
		color: #f2dcb5;
		font-weight: 800;
		font-size: 0.875rem;
	}
	&__icon {
		margin-top: 0.25rem;
	}
	&__tooltip {
		text-align: center;
	}
}
</style>
